import * as React from 'react';
import { Col, Input, Label } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ServerResponse, UserData } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';

export interface CPAccountProps {
    courseProviderUser: UserData;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    serverResponse?: ServerResponse;
    clearErrors: () => void;
    saveAccountMail: (mail: string) => void;
    saveAccountPassword: (pw: string) => void;
}

export interface CPAccountState {
    edit: string;
    email: string;
    email1: string;
    notSame: boolean;
    password: string;
    pwd1: string;
}

export default class CPAccount extends React.PureComponent<CPAccountProps, CPAccountState> {
    constructor(props: CPAccountProps) {
        super(props);
        this.state = {
            edit: '',
            email: '',
            email1: '',
            notSame: false,
            password: '',
            pwd1: '',
        };
    }

    public render() {
        const { email, password } = this.state;

        const hasErr = this.props.serverResponse && !this.props.serverResponse.OK;
        let vmess = '';

        if (this.props.serverResponse && !this.props.serverResponse.OK) {
            if (this.props.serverResponse.Error === 'validation_error') {
                if (this.props.serverResponse.Errors) {
                    this.props.serverResponse.Errors.map((entry) => {
                        if (entry.Parameter === 'Username') {
                            vmess += entry.Error === 'str_match_mail_failed' ? TR.cPAccount_enter_valid_email : '';
                            vmess += entry.Error === 'str_too_short' ? TR.cPAccount_email_min_length : '';
                        } else if (entry.Parameter === 'Password') {
                            vmess += entry.Error === 'str_too_short' ? TR.cPAccount_password_min_length : '';
                        }
                    });
                }
            } else if (this.props.serverResponse.Error === 'already_exists') {
                vmess = TR.cPAccount_email_exists;
            }
        }

        return (
            <CPItemEditComponent
                name="Konto"
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    this.props.clearErrors();
                    let notSame = false;
                    if (this.state.edit === 'mail' && this.state.email !== this.state.email1) {
                        notSame = true;
                        this.setState({ notSame });
                    } else if (this.state.edit === 'pw' && this.state.password !== this.state.pwd1) {
                        notSame = true;
                        this.setState({ notSame });
                    }

                    if (!notSame && this.state.edit === 'mail') {
                        this.props.saveAccountMail(email);
                    } else if (!notSame && this.state.edit === 'pw') {
                        this.props.saveAccountPassword(password);
                    }
                }}
                cancelHandler={this.cancelHandler}
                content={this.renderContent(this.props.courseProviderUser)}
                contentEdit={this.renderContentEdit(this.props.courseProviderUser)}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={hasErr}
                validationMessage={vmess}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.Account) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
            if (this.state.edit !== '') {
                this.setState({ edit: '' });
            }
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = (data: UserData) => {
        return (
            <>
                <Col md={2}>{TR.cPAccount_email}</Col>
                <Col md={10}>{data.Email}</Col>
                <Col md={2}>{TR.cPAccount_password}</Col>
                <Col md={10}>********</Col>
            </>
        );
    };

    private renderContentEdit = (data: UserData) => {
        const errorMsgIdent = <p style={{ color: 'red' }}>{TR.cPAccount_password_mismatch}</p>;
        return (
            <>
                <Col>
                    <div className="w-100">
                        <div className="d-flex flex-row">
                            <div className="w-50 my-auto">
                                <Label>{TR.cPAccount_email}</Label>
                                <Label className="ml-2">{this.props.courseProviderUser.Email}</Label>
                            </div>
                            {this.state.edit === '' && (
                                <button
                                    className="btn btn-secondary w-25 btn-sm mb-2 ml-auto"
                                    onClick={() => {
                                        this.setState({ edit: 'mail' });
                                    }}
                                >
                                    {TR.cPAccount_change_email}
                                </button>
                            )}
                        </div>
                        {this.state.edit === 'mail' && (
                            <>
                                <div className="d-flex flex-row mb-3">
                                    <div className="d-flex flex-column w-50">
                                        <Label>{TR.cPAccount_enter_new_email}</Label>
                                        <Input className="w-75" id="email" name="email" onChange={this.inputHandler} />
                                    </div>
                                    <div className="d-flex flex-column w-50">
                                        <Label>{TR.cPAccount_repeat_email}</Label>
                                        <Input className="w-75" id="email1" onChange={this.inputHandler} />
                                    </div>
                                </div>
                                {this.state.notSame === true && this.state.edit === 'mail' && errorMsgIdent}
                            </>
                        )}
                    </div>
                    <div className="w-100">
                        <div className="d-flex flex-row">
                            {this.state.edit === '' && (
                                <>
                                    <div className="w-50 my-auto">
                                        <Label>Passwort:</Label>
                                        <Label className="ml-2">********</Label>
                                    </div>
                                    <button
                                        className="btn btn-secondary w-25 btn-sm mb-2 ml-auto"
                                        onClick={() => {
                                            this.setState({ edit: 'pw' });
                                        }}
                                    >
                                        Passwort ändern
                                    </button>
                                </>
                            )}
                        </div>
                        {this.state.edit === 'pw' && (
                            <>
                                <div className="d-flex flex-row mb-2">
                                    <div className="d-flex flex-column">
                                        <Label>{TR.cPAccount_enter_new_password}</Label>
                                        <Input
                                            className="w-75"
                                            type="password"
                                            id="password"
                                            name="password"
                                            onChange={this.inputHandler}
                                        />
                                    </div>
                                    <div className="d-flex flex-column ml-2">
                                        <Label>{TR.cPAccount_repeat_new_password}</Label>
                                        <Input
                                            className="w-75"
                                            type="password"
                                            id="pwd1"
                                            onChange={this.inputHandler}
                                        />
                                    </div>
                                </div>
                                {this.state.notSame === true && this.state.edit === 'pw' && errorMsgIdent}
                            </>
                        )}
                    </div>
                </Col>
            </>
        );
    };

    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { notSame: false };
        newState[e.target.id] = e.target.value.trim();
        this.setState(newState);
    };

    private cancelHandler = () => {
        this.setState({ notSame: false, edit: '' });
        this.props.cancelHandler();
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPAccount.tsx